import { AppState } from '@/store';
import { Checkbox } from '@components/tailwind';
import FilterSidebar from '@components/tailwind/FilterSidebar';
import { useFilterItemUrl } from '@features/partner/hooks/useFilterItemUrl';
import { filtersAdd, filtersRemove } from '@features/partner/redux/partner.actions';
import { useState, useEffect, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAppDispatch } from '@/store';

const MIN_COUNT_SHOW = 6;

type Props = {
  rel?: string;
};

const SizeList = ({ rel }: Props) => {
  const dispatch = useAppDispatch();
  const {
    sidebarFilters: { sizes },
    filterOptions: { sizes: selectedSizes },
  } = useSelector((state: AppState) => state.partner);
  const { getUrl } = useFilterItemUrl();

  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (sizes) {
      setIsExpanded(!(sizes.length > MIN_COUNT_SHOW));
    }
  }, [sizes]);

  const onChangeHandler = (selection) => (e) => {
    if (e?.stopPropagation) e.stopPropagation();

    if (selectedSizes.indexOf(selection as never) >= 0) {
      dispatch(filtersRemove('sizes', selection));
    } else {
      dispatch(filtersAdd('sizes', selection));
    }
  };

  if (!sizes || sizes.length <= 0) return null;

  return (
    <FilterSidebar title='Size'>
      <ul className='tw-mb-0 tw-list-none tw-pl-0 tw-font-body tw-text-sm tw-font-normal'>
        {sizes.slice(0, isExpanded ? sizes.length : MIN_COUNT_SHOW).map(
          (option, i) =>
            option && (
              <li key={option.id} className='tw-mb-5 tw-block'>
                <Checkbox
                  labelClassName='tw-font-normal'
                  size='lg'
                  checked={selectedSizes.indexOf(option.id as never) >= 0}
                  setChecked={onChangeHandler(option.id)}
                  name='sidebarSizes'
                  id={`sidebarSizes-${i}`}
                  label={
                    <a
                      className='tw-appearance-none hover:tw-text-body hover:!tw-no-underline'
                      href={getUrl(
                        selectedSizes.indexOf(option.id) >= 0 ? 'remove' : 'add',
                        'sizes',
                        option.id
                      )}
                      {...{ rel }}
                      onClick={(e) => {
                        e.preventDefault();

                        onChangeHandler(option.id)(e);
                      }}>
                      {option.value}
                    </a>
                  }
                />
              </li>
            )
        )}
      </ul>
      {sizes?.length > MIN_COUNT_SHOW && (
        <p
          onClick={() => setIsExpanded(!isExpanded)}
          className='tw-cursor-pointer tw-font-body tw-text-sm tw-font-bold tw-text-body tw-underline'>
          {isExpanded ? '- Show Less Sizes' : '+ Show More Sizes'}
        </p>
      )}
    </FilterSidebar>
  );
};

export default memo(SizeList);
